module.exports = __webpack_public_path__ + "static/media/gogole-play-icon.d5c021ce.png";